import type { ComponentProps, ElementType } from 'react'

import clsx from 'clsx'
import { typo } from 'shared/styles'

import css from './Button.module.scss'

type ButtonOwnProps<E extends ElementType> = {
	as?: E
	shape?: 'rect' | 'square'
	typography?: string
	variant?: 'bordered' | 'bordered-dark' | 'danger' | 'primary' | 'secondary'
}

type ButtonProps<E extends ElementType> = ButtonOwnProps<E> &
	Omit<ComponentProps<E>, keyof ButtonOwnProps<E>>

export function Button<E extends ElementType = 'button'>({
	as,
	className,
	shape = 'rect',
	typography = typo.buttonSmB,
	variant = 'primary',
	...props
}: ButtonProps<E>) {
	const Tag = as ?? 'button'

	if (Tag === 'button') {
		// @ts-ignore
		props.type ??= 'button'
	}

	return (
		<Tag
			className={clsx(className, typography, css[variant], css[shape])}
			{...props}
		/>
	)
}
